import { GridTableRow } from '@/components/ui/grid-table'

export interface DocumentTableSkeletonProps {
  rows?: number
}

export function DocumentTableSkeleton({ rows = 6 }: DocumentTableSkeletonProps) {
  return (
    <div>
      {Array.from({ length: rows }).map((_, i) => (
        <GridTableRow key={i} interactive={false} className="animate-pulse">
          <div className="size-4 rounded bg-muted" />
          <div className="flex items-center gap-2">
            <div className="size-4 rounded bg-muted shrink-0" />
            <div
              className="h-3.5 rounded bg-muted"
              style={{ width: `${100 + ((i * 23) % 80)}px` }}
            />
          </div>
          <div className="h-3 w-8 rounded bg-muted max-md:hidden" />
          <div className="h-3 w-10 rounded bg-muted max-md:hidden" />
          <div className="h-5 w-16 rounded-full bg-muted max-md:hidden" />
          <div className="h-3 w-20 rounded bg-muted max-md:hidden" />
          <div className="h-3 w-24 rounded bg-muted max-md:hidden" />
          <div className="h-3 w-24 rounded bg-muted max-md:hidden" />
          <div />
        </GridTableRow>
      ))}
    </div>
  )
}
